import React, { Dispatch, FC, SetStateAction } from 'react';
import { View } from 'react-native';
import { RightColumnLevel } from '@components/ncFileVersions/types';
import Selectors from '@styles/selectors';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import i18n from 'i18n-js';

interface NCFileVersionDetailsModeSelectorsProps {
  rightColumnLevel: RightColumnLevel;
  setRightColumnLevel: Dispatch<SetStateAction<RightColumnLevel>>;
}

const NCFileVersionDetailsModeSelectors: FC<NCFileVersionDetailsModeSelectorsProps> = ({rightColumnLevel, setRightColumnLevel}) => {
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
      {Object.values(RightColumnLevel).map((l) => (
        <Selectors
          key={l}
          {...{
            scale,
            font,
            selected: l === rightColumnLevel,
            variant: 'L',
            text: i18n.t(l),
            onPress: () => setRightColumnLevel(l),
          }}
        />
      ))}
    </View>
  );
};

export default NCFileVersionDetailsModeSelectors;
